/* istanbul ignore file */
import React, { useState } from 'react';
import moment from 'moment';
import { FormFieldsData, DateInput } from 'framework/form';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import useJournalEntryService, { READ_JOURNAL_ENTRY_LIST } from 'domain/finance/journalEntry/useJournalEntryService';

const DownloadJournalEntriesCsvReportButton = () => {
  const { downloadJournalEntriesCsvReport } = useJournalEntryService();
  const { getToday } = useDateService();
  const [periodErrors, setPeriodErrors] = useState<string[]>([]);
  const [period, setPeriod] = useState<string>(getToday().format(DATE_FORMAT.API_ONLY_MONTH));

  const onPeriodChange = (values: FormFieldsData) => {
    const currentPeriod = values.period as string;
    setPeriod(currentPeriod);
    const isValid = moment(currentPeriod, DATE_FORMAT.API_ONLY_MONTH, true).isValid();

    if (!currentPeriod) {
      setPeriodErrors(['Field is required']);
    } else if (!isValid) {
      setPeriodErrors(['Please, choose the correct date']);
    } else {
      setPeriodErrors([]);
    }
  };

  return (
    <ButtonWithConfirmation
      displayMessage="Do you really want to download journal entries report? Please, fill out the period below."
      modalChildren={
        <>
          <DateInput
            source="period"
            label="Period"
            value={period as any}
            onChangeCallback={onPeriodChange}
            errorMessages={periodErrors}
            isRequired
            dateFormat={DATE_FORMAT.API_ONLY_MONTH}
            sx={{ mt: 2.5 }}
          />
        </>
      }
      submitMethod={() => downloadJournalEntriesCsvReport(period)}
      permissionToCheck={READ_JOURNAL_ENTRY_LIST}
      variant="outlined"
      confirmBtnProps={{ disabled: !period || !!periodErrors.length }}
      afterSubmit={{
        successMessage: 'Journal entries report successfully downloaded.',
        errorMessage: "Can't launch journal entries report download.",
      }}
    >
      Download journal entries report
    </ButtonWithConfirmation>
  );
};

export default DownloadJournalEntriesCsvReportButton;
